import React from "react";

function CustomButton({ className, isdisable, action, label, icon }) {
  return (
    <button
      type="submit"
      className={`btn-class ${className}${
        isdisable === true ? " custom-disable" : ""
      }`}
      onClick={action}
      disabled={isdisable}
    >
      {label}
      {icon && <span className="button-icon">{" "}{icon}</span>}
    </button>
  );
}

export default CustomButton;
